import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=ec7eabbe&scoped=true&"
import script from "./ClockWidget.vue?vue&type=script&lang=js&"
export * from "./ClockWidget.vue?vue&type=script&lang=js&"
import style0 from "./ClockWidget.vue?vue&type=style&index=0&id=ec7eabbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7eabbe",
  null
  
)

export default component.exports